import { render, staticRenderFns } from "./basicConfig.vue?vue&type=template&id=59760cfd&"
import script from "./basicConfig.vue?vue&type=script&lang=js&"
export * from "./basicConfig.vue?vue&type=script&lang=js&"
import style0 from "./basicConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59760cfd')) {
      api.createRecord('59760cfd', component.options)
    } else {
      api.reload('59760cfd', component.options)
    }
    module.hot.accept("./basicConfig.vue?vue&type=template&id=59760cfd&", function () {
      api.rerender('59760cfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/basicConfig.vue"
export default component.exports